import { Box, Grid, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormSwitch, LwFormInput } from 'redesign';
import { CompanySettingsDataForm } from './settings-edit-page';

export const SettingsEdit = (props: {
  companyData: {
    offersFreelanceWork: boolean;
    offersTempWork: boolean;
    offersEmployeeWork: boolean;
  };
}) => {
  const { control } = useFormContext<CompanySettingsDataForm>();
  const { t } = useTranslation('ogp-screen-specific');
  return (
    <Grid container spacing={4}>
      <Grid item xs={4}>
        <SwitchesContainer>
          <FormSwitch
            name="requiresEmployeeContract"
            control={control}
            disabled={!props.companyData.offersEmployeeWork}
            label={t('settings-edit-page.employee-contract-requested-label')}
          />
          <FormSwitch
            name="requiresEmployeeCertificates"
            control={control}
            disabled={!props.companyData.offersEmployeeWork}
            label={t('settings-edit-page.employee-certificates-requested-label')}
          />
        </SwitchesContainer>
      </Grid>
      <Grid item xs={4}>
        <FormFieldContainer>
          <LwFormInput
            name="employeeMutableUntilHours"
            inputType="number"
            control={control}
            label={t('settings-edit-page.employee-mutable-until-minutes-label')}
            placeholder="0"
            rules={{
              required: 'Voer een fee in',
              min: {
                value: 0,
                message: 'Min is 0',
              },
            }}
          />
        </FormFieldContainer>
      </Grid>
      <Grid item xs={4}></Grid>
    </Grid>
  );
};

const FormFieldContainer = styled(Box)(() => ({
  maxWidth: '400px',
  width: '100%',
}));

const SwitchesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  maxWidth: '400px',
  width: '100%',
}));
